import {Action, Module, Mutation} from 'vuex-module-decorators';
import {CountryModel} from '@/models/country.model';
import {CountryApi} from '@/api/country.api';
import {delay, take} from 'rxjs/operators';
import store from '@/store';
import {EntityStateAdapter} from '@/store/base.store';

export const featureKey = 'countries';

// @ts-ignore
if (store.state.countries) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class CountryStoreModule extends EntityStateAdapter<CountryModel> {

  private _timezones: string[] = [];

  @Mutation
  requestAllTimezonesDone(timezones: string[]) {
    this._timezones = timezones
  }

  @Action({commit: 'requestAllTimezonesDone', rawError: true})
  async fetchTimezones(): Promise<string[]> {
    if (this._timezones.length > 0) {
      return this._timezones;
    } else {
      return await (new CountryApi())
        .allTimezones()
        .pipe(take(1))
        .toPromise()
    }
  }

  @Action({commit: 'insertMany', rawError: true})
  async requestAllCountries(): Promise<CountryModel[]> {
    this.updateLoading(true);
    return await (new CountryApi())
      .all()
      .pipe(take(1))
      .toPromise()
  }


  get countries(): CountryModel[] {
    return this._entities;
  }

  get timezones(): string[] {
    return this._timezones;
  }

  get loading(): boolean {
    return super.loading;
  }
}
